module.exports = __webpack_public_path__ + "static/media/calendar-green.a3739d4f.svg";